import React,{useState} from 'react'
import SalesReturnForm from './SalesReturnForm';
import SalesReturnList from './SalesReturnList';

const SalesReturn = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <SalesReturnForm addForm={setFromIsShown} update={upData} />
      ) : (
        <SalesReturnList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
  )
}

export default SalesReturn